import ManageAccount from 'features/accounts/ManageAccount/ManageAccount';
import React from 'react';

export default function Page() {
  return <ManageAccount />;
}
